import { createBrowserRouter, RouterProvider, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Teams from "@/pages/Teams";
import TeamSettings from "@/pages/TeamSettings";
import Playbook from "@/pages/Playbook";
import PlayEditor from "@/pages/PlayEditor";
import LearnPlay from "@/pages/LearnPlay";
import Help from "@/pages/Help";
import Join from "@/pages/Join";
import ViewerPlaybook from "@/pages/ViewerPlaybook";
import CoachInvite from "@/pages/CoachInvite";
import PrintPlays from "@/pages/PrintPlays";
import Admin from "@/pages/Admin";

function Protected() {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center bg-[#070D18] text-slate-400" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return <Outlet />;
}

function PlaybookRedirect() {
  const { activeTeam, teams, user } = useAuth();
  if (user && !teams.length) return <Navigate to="/teams" replace />;
  return activeTeam ? <Navigate to={`/teams/${activeTeam.id}/playbook`} replace /> : null;
}

const router = createBrowserRouter([
  { path: "/login", element: <AuthPage mode="login" /> },
  { path: "/register", element: <AuthPage mode="register" /> },
  { path: "/join", element: <Join /> },
  { path: "/join/:token", element: <Join /> },
  { path: "/view", element: <ViewerPlaybook /> },
  { path: "/view/play/:playId", element: <LearnPlay viewer /> },
  {
    element: <Protected />,
    children: [
      { path: "/play/:playId/edit", element: <PlayEditor /> },
      { path: "/teams/:teamId/print", element: <PrintPlays /> },
      {
        element: <Layout />,
        children: [
          { path: "/", element: <Dashboard /> },
          { path: "/teams", element: <Teams /> },
          { path: "/teams/:teamId/settings", element: <TeamSettings /> },
          { path: "/teams/:teamId/playbook", element: <Playbook /> },
          { path: "/playbook", element: <PlaybookRedirect /> },
          { path: "/play/:playId/learn", element: <LearnPlay /> },
          { path: "/help", element: <Help /> },
          { path: "/coach-invite/:token", element: <CoachInvite /> },
          { path: "/admin", element: <Admin /> },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <Toaster theme="dark" position="top-center" richColors />
    </AuthProvider>
  );
}
